import React from 'react';
import PropTypes from 'prop-types';

import useRandomId from 'hooks/useRandomId';

const IconJoybirdLogoPride = ({ className = '', height = 22, width = 100 }) => {
  const logoId = useRandomId('IconJoybirdLogoPride');
  const clipPathId = `${logoId}__clipPath`;
  const titleId = `${logoId}__title`;

  return (
    <svg
      aria-labelledby={titleId}
      className={className}
      height={height}
      role="img"
      viewBox="0 0 100 22"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title id={titleId}>Joybird</title>

      <clipPath id={clipPathId}>
        <path d="M.27 20.36h99.36v1.38H.27z" />
      </clipPath>

      <image
        height={609}
        overflow="visible"
        transform="translate(-5.65 -12.108) scale(.0703)"
        width={1583}
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABi8AAAJhCAYAAAA5XyPaAAAACXBIWXMAACxKAAAsSgF3enRNAAAg AElEQVR4nOzdTVJbWdYu4HMrqqsg7whwjQDXCCBHYHIEJvuKMNlVx7ijrnGE+sYjKDyChBEkjKDM CG4SGkDd2M4lp4wA86OfvfZ5nggi84r86oKEjvbZ715r/Z///e9/HQAAAAAAQC3+4ZUAAAAAAABq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwA AAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAA AACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACqIrwAAAAAAACq IrwAAAAAAACqIrwAAAAAAACq8k8vB+s0GI6Ouq57W/mT/vN0Mj5beBQ2bDAc7cVP8CK+ip+6rnt5 y0+2u/DIovOFR7ruouu6P+Pfv8RX5z3RP4PhaL/ruv8k+sWvy3thOhl/WfgOvTIYjg67rnuf4He+ nk7GPy08uiLxGfL7un/JhC7nPgdv82d8Vs779nkZLqaT8X3/GySU5D6mOJ9OxnsLjzbKte2bqxvX oZsublzbvruWWeu3bzAc/a/vz8ENP3rP3Obm+2jebeuDzpoAnk94AVCJwXA0CyJeRiixF//cWdFP eFvAcdtj5Web/ess8DibW6BZkDVoOhmfDoaj87v+Jiq01XXdSbxv6Km4jh4l+e0PFh6hBg/5zH21 8MgNc5+bszBkFnDMPjv/nE7Gt21yADzFdnzd5d713Nw163puA/bixjVLwEFLfvSeuc2976O7zL2/ uhvvse6W0GP+feY+m97rhBcAmzEYjl7OBRWzr60EL8fujX9+NRiOZouws7lAwwn4/A7i9czwt1ns loqRErwsfIe+OEny9/rZ32lvzMKQhQ2P2My4jFDjwucnUIGte9b73dzG68Xs2iXUgEfZumVNMH8o 4rsKv1sOEToMQe8ILwBWLE4C70VAsXfLYqUFs0XYt9/tRqBx5sYmn7KBNhiOjpO0yZg5HgxHZ04p 9U+0OvvhifgKlGvjYd9fL77Zia9vf7uD4ehq7vPzVJgBVOS2NX8XQezZ3LrfOgyW69ZQsVsMFr/M HYr4ItigBcILgBWITbS9+FpV26fazd/cvI1F1fncZoyFVALTyfhoMBwdPKGselO2o22QzeEeiZD4 JMlvfGQzmh+YtbIogcb7CDNOY0NQxQ5Qo1kQ+6b763P5Mq5b1vywHgvBYnd7leeZdlRkI7wAWILB cFQGaM8CiwwnfzdlPsy4nm3GxI2NBVS9DpINw3wzGI5O3Cz3ylGSdlFlkO7xwqNwv+3YEHwz99l5 7BoHVGwWZrydC2CtzWAz5qs8v1bUR8A43yXBwRqqJbwAeKKYW3HQ8+qK5ygbja/j62MMhz7VIqM+ peXXYDj6FK9VFifRqo3GDYajvdlJzwRUBPFc3z47Y0PwODYEHQAAajUfwLpuQR1mgcbX+7v5Kk+t 36iN8ALgEaLC4iC+srTRyWJWlfE+ToIcq8ioymFUF2UZ3r0zGI4OnXLvhSztot45ccqSlXXI+1J5 NBiOTrUkAxKYXbfex8EYVWRQh28hY/fXvsfnuZaV1hZs1D88/QD3K73US8//wXBUFtb/jVJLwcVq lVMgH7uu+39lQyZmiLBBESJlOzV+FLMQaNRgODpKcj2+KvNjFh6F5ZhVY/y3tMyLgxYAtSvXrT8G w9FZVFEC9XgV9+NlbXER+yHuq9gI4QXAHcoiumwClA30+ODWGmozysLpP4Ph6M/BcHRsU2ZzppPx SQxdz2Ir0al8Hila971N8rwdLDwCqzELMY5tMgBJlMrr3yPE0PIT6nPzYKF1LWslvACYM1dl8SUG FGfq8d+6rShj/a9qjI3Ktlh95TRfs7IEUx/K3JiFR2G1yuflFxsMQCK7UYlxInyFar2KeZUOFrI2 wguAmGVRPnzLjX6cKtAWqm6zaowvSljXK3qevkv2Y6u+aEyZZ5KkGu66tC9beBTWYys2GM5sLgCJ vI7wNVu7UuiT+YOFZw4WskrCC6DXIrQ4iVkWbxINI+Yv2xE2lRsc8w3WpwR9V4l+3u2YjUADYhM2 y+t5EPNiYJPKaeYLVRhAIlsx1Fv4CvXbnT9Y6PVi2YQXQC/FPIuzCC20hspvK3rff1G+unqxGZtt YfrW30UzTpIEzZ+nk/HpwqOwGbMqDO1YgEyEr5DH9lxLKQcLWRrhBdArc6HF77EYpi3z5auGla5Q 9PD/nOzH1j4qudi8yHDtLu2itLugRuXAhpPMQCbCV8hl/mChEINnE14AvTDXHkpo0R9vLJhW7iA2 abPYdXIvr3gfHyf5BY5iPgzUaCdOMr/06gCJzMJX63rIYT7EcA/GkwkvgKaVxe3cTAvtofpnfsHk FPSSRfuobLMkVOTklaVd1Pl0Ms4SstBf5b30h80EIJmdWNcLXyGPWfVUee/ued14LOEF0KwY0PtF aMHc0D8LpiWLTdrzRD/yVsLApfcGw9F+13WvkjwPglIy+SjAAJLZigoMa3rIpczE+N0gfh5LeAE0 J+ZafIkT9xlO6bI+FkyrkW2z9o0b3jyStYt6N52MLxYehboJMIBstmJN79oF+ezGjEoHyngQ4QXQ jJhrcRpzLba9stzDgmmJYrP2XbIfW1ufPI6SXNOv/F2RmAADyMi1C/J6qzMCDyG8AJoQ8wwuErUV oQ4WTMtzHJu3WeyYg1K/eG++SfLjHsQcGMjKJiCQ0cdoLwnkM+uMYC4hdxJeAKmVYW2D4aiEFu+1 iOKJLJiWIDZts4UBR9qHVe8kyc/5aToZny08Cvl8NAgXSOjEtQtSK4eVLryPuY3wAkgrWv78UU5Q exVZgtmCSRXGE00n49K27XOiH3lLm596xTU+Q7uoa0O6aYy5UEA2syHeNj4hr7Lu/0NrZ24SXgDp xGyLixjIDcukCuP5DmMzN4tXWg3UJzYfslzjtYuiNWUT8NTnIJDMVlRguHZBbqW185n3MjPCCyCV 6MV8odqCFXvj9NbTTCfjLzFgORNhVX2yVMScR8URtGZHZRqQ0E6ilpPA3Xa7rjObkq+EF0AKZWNx MByVDaKPZluwJjtRtqodzCNNJ+Oy4XWZ6Efe1vanHvGe203wo5YKI8ONadlrA7yBhF5pOwNN2Iqu CO7Tek54AVQvTr+XaotXXi024H0JzpzMf7RsG15vVdpsXvTZz7LhcBSVRtCyY/MvgITeOrENzSj3 41rC9ZjwAqhanPj7I8nQVtr1KoZ529x+oOlkXALHDyl+2L9pkbJ5J0mq6y6jwghat6UFC5CUzU5o x+to6+w93UPCC6BaJV2PNlFQg+1YMGmh8XBHyYZ373p9NycGp2doF9VpF0XP7GrZACS0nXAOG3C3 HQcK+0l4AVQn5ltcRLoONSknUD8OhiMnrh9gOhn/mXCT1/DuDYjnPMvp7ndRWQR9cuTaCCT0Rvso aMrsQKEAo0eEF0BV4kPoS6TqUKs35mA8zHQyLoP2zzP8rGFL+6iNyNIu6srfBz3l2ghkpX0UtKWs Sf5QMd8fwgugGvHhc5ZkAwtexakPg0x/7CBZ+6jXTumtTzzXr5L8uAdRUQR99NpJRyChclJb6zto z0cBRj8IL4AqxIfOR8EFyei7+QDTyfhLwhO7ThivQbJ2UZ+mk/HZwqPQL66NQEaHDhxBkwQYPSC8 ADbOYG6S24oKDCf17zGdjMvAxMu7/4vq7AyGI0MeV+8oTkTW7tqpTfhq1+cdkNCW4d3QLAFG44QX wEZFcGEwN9mVG6LfLZp+KNvmr1N6KxQboG+S/LiH2kXBNzYAgYy0voN2CTAa9s++PwHAZsy1CsnS 5xweoiyaSpVBljY4a1Va7gyGo0+JAsutuE45ZbwaWdrPnHtPr9VvpR3fiv8/vPmefhFfs3/PUA20 SV+rL7RRAxI6vuUzAGiDe/FGCS+AtYvg4izmBUBrLJruV6ov9hPNtymbdPvTyfh04Ts8WbTkyvAZ cB0D51mfizVsij/of3+uPVL5Z1m7vIwv87n+qr6wAQiP8/MTnq/Zteem+fef0PXhyrru5XQyXnVI DmyGe/EGCS+AtRJcLM11nEz9c+6E6pf4+s5sEyie+9tufl7GjVE3dyO0u/Bf8Rgf41SqTc8bSuud wXB0mGzOzfFgODrTNmg5omXD2yQ/7nEMnKeH5kKU78KOuc/Tvbl/9i3QKBuAL7w/4OGeEcw++ADF XOj6ci74eOHe6zuHDiZU7byyH044mE+5F78QUrZDeAGsjeDiSWYhxdksnHjqjU9svN72f3vbY/Ob My/mTpsKNR7udZz6cHN0QzkJEz1Js/w9bccpYwOblyNLu6jLGDQP35n7PP32+RnzcfYjyOhLS8wj G4BQl7tC1+7vwwMvreu/rtGPhK91mk7GKav67jkoePP3mf9/q+ZcnbM4TCjAaIDwAlgLwcWDXcbz 9DWw2OSi+q6wY+7GZy++nES52+s49ZFls3adyobXfxP9vG8Gw9GJBfDzRNVNls0Sm7I8WHxeH8/C udJuLv6GWg4y9sv6TlUa5BBrmO/WMVGpsRfha5/u0w4dSmGZ7rp3vuOxBbdUTb2YO0Qo4Hi8rQgw Xlin5Ce8AFZOcHGv6ygFP9t0WPFQczc+X/tIRpix17PTpo/xfjAc/anv5vfK3/pgOHqXqH1QZ8jj 88TJ9CyVDB8EVTxHzMk5jTXQrEVJa2H/Vmx4+nyDpKJSo3wdzVWQHfTgvu0gqi9salKF+6qmur/D jVmgsSfUeJCtuQoM7/XEhBfAOgguvjcLLE5bGAI8F2YcxybNfnwJMv5mcNgtSkueaB+VZUOv9Hg/ VEnzZCdJbrKuEoUsVC5ulo9iY/Ag/r2lEONAeAFtmK8giyBjFry2uEEqfCWV21pHx/t0T0eEe+3E dU1FdWL/6PsTAKxWabMiuPjmU9d1v0wn49Ji4aCF4OKmsklTNuink3G5Gfi/Xdf9WuHQtU35GBtX fC/bc3IUIR2PEC100rSLcjqLVYgAu5yUfNfQE7wbmydAQ0qQMZ2MD+OU97s4fNUa63JSi/fpSewt lPfqv7qu+63rus9e2e+8jta1JCW8AFYmgovXPX+Gr2ID//+2GljcZS7I2IuF1IdGb3we42O02SLE KaJMC+wtp/QeJ8KeLM/Z59tOtsGyxGdjqb74d8y5asG+PxBo09w160VjwWsnfKU1EWYc3zhIKMj4 y/u5uSIkI7wAVqL0EO15cFEWCT+XExCxgd/rU7yz01ul6iQWUa1s2DzFmQBjwUGyYOuVxe+jHCdp OXHtFCbrEi0X96IqMzvhBTSu0eC1c/2iVTc6IswqMq56/oKfqqDPSXgBLF20xsk0hHeZyibEv8oi wend28Uiqmze/9zTllJbFk7fm+sJn4nqiweIkCdLkH3Y96CZ9YqNhYMGAoxdn2nQD40Fr51DC/TB XEVGqTT6pcdtnbdi9ijJCC+ApYqNqo89fFZnocVBDLvjB0q4Ey2l+hhibEcFhs2eEEOwM/0dbEeF GXdI1i7q3EB9NqWRAMPpZeiJueD1twZ+4x2to+iT0sY67sH/3VAI+Ri77uHyEV4ASxOtcPqWZAst nqnHIcZOtNPhb9kGqb11w3uvowjqaqddFBsXG4GZ+1JrpQc9EwdPfm3gtxa+0juliirWHv/q4VyM t1oA5yK8AJZi7oRthr7my1A22f8ttFieuRDj1x7143zt5MffohVBtmGQTuvfIsLsN4vfqdKx6ziV OEjcS94mAPRQVC1mH+Tt+kVvRUup/R4eJDzRBSEP4QWwLCdxkrx1ZVP9l7LJHhutLFnMxHgRN0KZ hjg/VTn54cTX346ThVe7Xr9bZQl1LmMAKWxczFzJWgW0rRIN+ik+RzO3n3m18Aj0zI2DhH24B99O OHOxt4QXwLPFyfE+LPo+dF33svSJXPgOSxc3Qi97cgLkxKbPX2LzLlv7KCd35sRnQpYwO9vfGo1L WoE283LhEaAvDjNXTmshA3+JaqoXPWkl9cZ7PwfhBfAscbF/2/izeBktog5jY5U1iTLW8jf2S+Mn QEq7tVMb4H+JgDDTgnnLyZ2/RAiX5TPhQzlltvAobF62CrQZ4QX0VPLKsU7rKPhbDOXf78E9eOcQ Wg7CC+DJYpOq9SqEd9PJ+KUWUZsVm9kvGq/CMMD7e4fJFstO7vwlS7uoK4ETtYpNwIx/n66B0GNx ICBr+yjXL7ihJ/fg2yqx6ye8AJ6j5QHdZWPrZ73Q6xEnQMqNxW8NnwApA7wzn1pbmhignO391+vw aTAclYX/7sI36qSSjqpF24Zs1RcqL4Bsh09mXL/gFnP34NkH89+nzKB0DaiY8AJ4kuhpnmWT6rE+ x2wL7UQqNJ2Mj+N01GWjv+Kx+Rd/idc60+u8Exv4vRN/s1nCps9mF5FElkqmmS2tF6Df4mBAxsMc W9bfcLc41NlyGykdEComvAAerfE5F7+V/o5O5NYt2njtNTpIbKsH7dgeI1slylFPb36Pk1TiXSfv yU2/ZAsvOqeXgaTXrs71C+4Xh3/2Gg0wdnVAqJfwAniUOFGXdUF6n+toEyVxT2JukNhvDf56O1Hd 1HsRVH1I9Dxs9e3kzmA4Ku/DVwvfqNORcJoson1etpDe5h/0XFy7Ms6+cP2CH5g7RNhiF4QjFaR1 El4Aj3UUQ41acqlNVF4ROLVYwqr35t+Okr2+r/oyvDtZoH0uoCahbJV4bvqBTuUYtKvhAMPw7koJ L4AHi824N409Y+flgzdOCJFUwyWsLVY5PVqclM9WxnvSk5M7WdpFddpFkVS28ELPeKCLQ2FXyZ4J 4Ss8UNyftRhgHKq+qI/wAniQRttFfZpOxntaiLQhToC8aGwBpX1UiIDqfOEb9Wr+5E4E2q8XvlGn d0JqMoo1SqbPNeEFMJOtqn134RHgTo0GGFtR9U9FhBfAQ7XWLqoEF07hNqbRBZT2UX87SFZd87bV 4d3JAu3L6WTsJoTMtLUEMspWOdY5cQ2P0+j995tW7+GyEl4AP9Rgu6gPgot2NbqA0qf/7wGQ2Z6L Vlt/HSYKtPWuJbuLRD+/k8vATMbg1YEheKS4/95vrIWzg08VEV4AD9HSxumv08nYRlbjGgwwdgfD kb/bv17bo2Sva3ntmgpLoxLo7cI36vQh+m5DZpnCC4CvEra9A54oDpm1NIPyteqLeggvgHvFhunO ff9NIiW4MAC5JxoMMI6Usn+TLcg5buy1y3IdvXJqihbETCeAjLIdILBZCU8U65WWDm25j6iE8AK4 U2y2tXLB/iC46J/GAowt7aP+EifpPy18o17NvHYxQD5LoH0Y1wBogdPLQEZfkv3Mwgt4hulkXGbd /NbIc6j6ohLCC+A+x7Hplt0nraL6q7EA47Xh3d8cJitLfh3zg9KKxXuWa+nnuHmCVgjigIxUjkHP TCfj42QHze5jVmoFhBfArWKD9PVt30vmk+HczAUYVw08Gaov/n5N07WPWngkl5Mkgfa1Gw0aZAMQ yMi1C/rpsJHDg4daN2+e8AK4SwsbpJ8FF8zEZvd+A0PEygDo/YVHeyhawZ0n+s13ou1SOjH/aDfJ z32kXRQN8jcNpJPw81iLGFiCeO8fNHDvveVQ1OYJL4AF0dokyybVXS59yHBTDBFL3bonqL74W7b3 +WG23qnJ5h+dR6k6AFCHTJXPwgtYkrj3bmGGqhbkGya8AG6T/QOmpPt7Tt5ym1hE/XrLtzLZHgxH wrm/Xs8yCPLdwjfqlXF4d5Z2UZ2bCxqm9QqQVbah3cCSxKGiz8mfz22dDzZLeAF8p4GqC8EFPxTt hj4kf6ZaOMWyFNPJ+CjZqb5XWRbA8XO+WvhGnd5FOAktsq4BADJqoX2Ug4MbJLwAbjpZeCSXQ5tX PMR0Mj5MNi/hJtUX38v2XBzXPvwtfr4snwlXEWIBAACViIOl2aujX2Vr/dsS4QXwTZyw3U78jHyI E/XwUPvJTuzfZLM2TCfjs2QlydsJXr+jRO2iBHkAUKczrwv0W+zTZD442Lnf2BzhBTAvcxp+GSfp 4cHiFEjm/pWqL76XrST5zWA4ernwaAWiheCbGn+2W3yI8AoAAKhT9vtW990bIrwAvko+6+I6+QY0 GxRtxn5L/BqovggRRmV7Pqob3p2sXdS19wBU5dLLAQDcNJ2My/D+dwvfyGM79s1YM+EFMJN58+cw PgjhSaaT8XHiMlbVF3MSvpa7g+Gotqqxw0QtBA8itALq4P0IZOaeElbrOPnwbvfdGyC8ALoYPJS1 6uKzORcsSbaWQ/OcPP9ethZyR7UM7442Vm8XvlGncv0/TfKzQl8IL4DMhBewQkkr5efp+LEBwgug S/zhcS35Zlmieifre0EJ65xoBZapJHmrovZRmdpFmXNEn2S5xl8sPAL0XRUHNIA6RKX8VdKXY2sw HAkw1kx4AT0Xp31fJ30WtAthqZK3j1J98b1si+LXmw6gon3VzsI36nSkXSBUyboMuOnlwiNA36m+ 4MGEF0DWygXtQliVrO2jdqMFHH+XJGc7mb+xqof428lyE3EeQSP0SZbru8oLAOBe0fo7a/WF8GLN hBdAxrYb2oWwMnGaO+vGqPfFnAg4Py98o16l/demAoSTaF+Vgb9z+ihLeKEiCsjszKsHa5O1+kLr qDUTXkCPxQV3O+EzcKxdCKs0nYyPkp4EMQNm0WGySpq3666gGQxH5e9md+EbdXoXM02gbzK0Xbm2 PgNukWWNAaxRVF9k7HjQqb5YL+EF9FvGC+5VbCzDqmUMArZiI5qQdBD72tpHxdyjLJVGrv/0UrxP M1RGCRYBgMfI2vFgo7MK+0Z4AT2VeFC3jSvWYjoZnyUd3i28uCHmI1wufKNeu2ssRc7ULsrfNn2V 5QZZuxXgO4PhKNUGX6z/gfXJGl6Udr8ZqmKbILyA/spYdXEepYWwLhl76xvcfbtsG98nETKvTAQk rzb7az7YJxsK9FiWm2OVF8BN1qTAnaaT8Z9lnX/X9yun+mJNhBfQXxk3ZVVdsFbRWz/jYkoPzhvi tfyw8I16ba3ympesXdS1Id30XJZruoARuClTeJGx4hpakPWAqnvuNRFeQA/FqeupqwsAACAASURB VOydZL/5uVO3bEjG0MxG7+2yDWJ/s8Jy5PJcbC88WqeDOJUFvZNozXbpfQrcwslk4F6xz5PpHm1m d+ERVkJ4Af2UMSFWdcFGxMDnbNUXenDeIjbWsgU7Sz+JFP2n3yx8o04luD5N8rPCKmRZs3mfArfJ tLnnoBxsTsrZF2ucU9hrwgvop2y931VdsGkZwzPDjW8RG+GZ2gLsDIajZQcuWUqzr/0dQ5r3gPAC +E7CTb0vC48A65J1HaG6bA2EF9AzSVtGqbpgo5JWXzgFcreD2BjP4mhZw7sHw1GmdlFH8d6DXooq qQxrtquYKwQwT3gBPEis+TPOnRFerIHwAvon2yLyStUFlcg2SEzrqDvE4jhTafLWMtpdRXidpW1W 6Z+fsnwclkjVBZBZqvtO95ywcRkHd2c7GJyS8AL6J1t4oeqCKsQNTbbTIE6C3GE6GZdry+Xt363S 2wgfnuMogpAMtIui1yJ8fp3kOci42QCsULSMyrLm6JKtCaFVKQ9DRKUsKyS8gB6JtiOZhqZdO81H ZbJt0NgAvl+24d1PDnNjUZ1lI/SdFjSQpjrs0vsVuEW2NZbrGGzYdDL+M2mQKLxYMeEF9Eu2i+pJ fIBBFaaT8UmyWQk7y5qV0KKopvmQ6Fd7/YyTPVmq2K6StfSCpYsTy1kOm3i/At+JtUqmA3Od8AKq kbGaU6vmFRNeQL9kaxnlhpgaZVtQGdx9v6Nsw7sXHvmBZJsIB0Jr+izaw2X5nLmOUB9gXsa2v+Zd QB0yvhdVXqyY8AL6JdNF9TKG6kJtsoVqFlP3iI3yTK0Ndp9QfZFlc/GTYZnwtV1mlj7xDpkA30la dXGt/R3UId6LV8lejq0lzCbkHsIL6Im4mG4n+m2d5KNKEaplGtwtvPiBODmc6TV98InGwXB0kOTa f52wPzYs1WA4KteinSTP6rXwApgXrUoz3sM5OAF1yfieFF6skPAC+iPdvIuFR6Aemf4+t50EeZBM w813oyf+Q2Rp3aBdFL0WwUWWofrFsfcscMNxssNyM6cLjwCbpHUU3xFeQH9kuph+dkNM5bLd5FhM /UBU1Ly7/7+qyg9PPCequjifTsY2DuithMGFqgvgO7HmyHQdm6fyAuqS8T1paPcKCS+gPzJtXtrE omoRrn1O9CoJLx5gOhkfJeqxuh0bBffJUE1ynazqBZamtFgZDEdnCTf8Dh0yAWZiPfIx6RNiziJU Jt6T2eZe6HSwQsIL6IHoP5qphFd4QQaZ/k6FFw+XaSP9zpZQiQZmHtk0oI/iPfol4WDb85gTBJA9 uOi0KoZqZRuin2VmWUrCC+iHTBuXl07zkUSm8GI7Qkx+YDoZl1PQn+7/r6pxX/XFncFGRcr1XusZ eiWqLcpm2e9d120l+91VSgHfDIajo+TBRefQHFQrXeuowXCkddSKCC+gHzJdRC0gSSFCtstEr5bF 1MMdxiZdBgshRQxoz3Ca2yYovRGhxVFUW2TtC69SCvi6zoiWd2+TPxvnrmlQrWyVF53WUasjvIB+ MO8CVkPrqAZFMLUQClTqtuqLDD/7h+lknPGmBB4lNvlOIrR4m7DaYuZcpRT021wIe5Gw5d1ttIyC SkU1fDYOC67IP5v8rYCbslxEr21mkcxpolNnFlOPUDbpBsPRfpa5EbMb8GgPVvup7qtE4RA8WrwP 96O6qIUNvqv4fYAeimvaYXxlDWBvunZoDqp3lWx2q8qLFRFeQONisZllkZkxXafHStg2GI6uk7zH hBePV27S/0jwc36tvoghuhlaMR2YbURros/xXmzytxBYzJTPuH3vWeifOMSxn7jV3X1OXNegehfC CzrhBfRCpg1L4QUZlb/bVwl+7kwLvypEOPUuSXXNrPricOE7dfmctAwcvjMYjvZijbUXX62cRr7p UFUs9EPMzNqbC2Jbva4V2uBB/S6S3GfPCC9WRHgB7RNewGplCS++brbZOH6046hmqD38KdUXx5X/ nNeGdJNJVK+WddTsny/jxnSnJy/kr1HRBTRoLoSdBbF9OejyyaBuSCHb4QmHBVdEeAHtS5P+OtlH Upn+bp0GeaTSUiAGYv+e4Md9s/BIXQ61aGCTorXTTzd+hL25f599/6ceBRR3EVxAA6KaYv6rbyHs bczdghzS3TeUa65wdPmEF9C+LJUX5wuPQAKlkmEwHGV5qYQXTxCv8edkZcu1ObcRygP9nuia2irB BVQoKiVumg9lX8yt9V423vbpqVRdQBLJ7rNnyjXYNWbJhBfQviyblaouyOw8yYDW2256eZjDxvva r5J2UZCH4AJWZDAc/c9zu3GqLiCXa/df/KP3zwC0L0vfPeEFmWX5+73ZLoUHilN6bnif5tgpR6he 2Rz4WXABNEzVBeSTbZ/IYcEVEF5Aw6K3cxYWkmSW5e+37z3cn2U6GZeB2JeJf4VNuJxOxkIfqFu5 rr0s7Rm8TkCjrqOKFoBkhBfQtjSnrN0wk5zKof7Q/uhxPF9Qtw/llKDTyEDjjqaTcbrhv0CXbZ9I p4MVEF5A27LMu7haeARySRNe3DHskQeaTsYXsdnHj32I5wuoz1W0iTq0oQc07jyqZwFWLVP3kzSE F9C2LOGF036kZuOnd46Erj90ZUYIVOuDNlFAT1yrAoXUHIRCeAFUwQcSLThP8js4DfJMEVbpm3y/ A6EeVKd8Tv1btQXQI4fa4kFq1isIL6BxWdrD+ECiBVn+jvXhXILpZHyaKLBat89OdENVzqNF1J5W bkCPfJpOxidecGCNHBRcgX829xsBGbmRpgXl7/iVV7JXDuJ13+r7EzFHewaox3kMqRUmAn1zqUoW mpBtr8h94QqovABqoPIC1sdpkCWJNgQGQH7vSDsa2KgSIH6K9lB7ggugh8p1cN96BPLzPqZTeQHN s0kJ65PlVIi2UUs0nYyPBsPRftd1O838Uk93Pp2MhTmwGZ+7rivt7E7d6AM9VoKLPXMuANohvIC2 pShZcyqQRtgs6q/SluD3vj8J2kXBRlx1XVd6up9ZTwF8HdCtJTFAQ4QXAADPUDYMB8PRh67r3vT4 eXznlCNsxHbXdW/L12A46qLP+9nsSxUG0CO/GtANbNpgOHrhvmi5hBcAsBxZFigvFh5hGY6i8qCP Q9ouS/ushUeBTdiJr69h6mA4Op9rJ+VGGmiV4ALaVdYyu4l+uxeJ9gZSMLAbAJYg0abQ9sIjPFuc bj7s6TPZ198bMig3+++7rvvvYDgqVWIHg+HI7COgFdeCC4C2CS+ATTv3CgAtiBvnvl3TPuizD2mU IONjOQ04GI5OSlsDLx2Q2Gw4t+ACoGHCC2iUG1KAjejT0OqraJcF5FLa272OagwhBpBRme/z0nBu gPYJL6BdbkQB1izah73ryfN+aBgwpCfEALL5FBUXesoD9IDwAgBgiWJ49VXjz+nn6WR8uvAokNUs xDgyEwOo1Gy+xYHDEwD9IbwAAFi+lttHXfesPRb0yduu6y4Gw9G+Vx2oyHm0iTLfAqBnhBcAAEsW Q6w/Nfq8HjnxCE3b7rruP9FKShUGsEnlwMRv08lYmyiAnhJeAACsxmHcdLfkfDoZH/t7gV54HVUY L73cwAaUQyAvrDsA+k14AY2KU78AbEhUJxw19vxrFwX9Uqow/hgMR977wLqUFlE/m20BQCe8ACrw wosAtCpOC5438uu907IBeutjaSPl5QdWaBZa7DmIB8DMPz0TwIZtewFgrVprY5RBaR/1R/Lf4Wo6 GbdWRQI8zuvBcFT+Dw6dhgaWqLSHOhFYAHAblRcAsASD4WgvyfN4sfAIKzWdjMtz/i75s6xlDNDF HIwzg7yBZ7qKtdG/oj2U4AK4y+4dj9MTKi8AAFbvOAKAjNVmH2wqAHN2IsDYU4EBPEKp/j0tX9PJ +NQTBzTKYcElU3kBbNxgODL3AmhabPBlrF64bnDoOPB8OyowgAe4jrZQv0wn45+iykJwATTLwY7l U3kBbTtPUmJXwgtDYMnupVeQ+5TqhcFw9Lnrulf3/Ge1ObAAB+5QAowyxHv/9m8DPVXuQc+iwsIJ ZACeRXgBAMuR5fSpm8jNKsO7y3yUrQQ/62enI4EfeDUYjsqgXXNxoJ8u4xBaCSsutJkElkmXDjrh BVCJvVjwQmZZFlZO0W/QdDL+Ujb6uq57k+DHPV54BGDR68FwdDadjE8WvgO04jzWkBcRVnwRVABr ILxAeAGN+5KkbRS0wMKKhxIgwd1+rmVDLE77zV/b5//fL6Pi7kXSQfzL9nEwHNnMhDZdRxtJbX4B 7nd173d5EuEFtC3LAnNv4RHIJ0t4oW0UwAPERt2D1lKD4ehlBBqzrz4eHjktgY85OfCdyxuHFn6K eTGZlFaXp+a7ARuQpTXzjJB3BYQXQA2yfSDBbbKcvLWpBLBkMZT2u3B4MBztxQGN/YSblU+xZYA3 LDi8WZFU2qwlDDh3BsPR8XQyPlz4DsDqCE3p/uEpgKZlKd3vww09DYsNqiycBgFYg7JhOZ2Mj6aT cbnx/lfXdb/FKeyWlQHeNjfhfvvRiimbN4PhSDgJwFoJL4AqRLsFyCrNvAv9igHWr1x7p5Px8VyQ 8Snp5uVDHMW8EOAW0Votawhw4v0NrFG2FuNmf62A8ALalqm3vUUwmWX5+zVADGDDIsg4iM+Odw2G GKV91PHCo8A30UrqXcJnZDb/AgDWQngBDUs2MFHlBZllORGi6gKgEmWdVtpKRYjxobHX5VWyloqw dvH+P0/4zJf5FycLjwIsX7Z9IvMlV0B4Ae3LsiB2g0tmWRZVwguAykSIUeZE/LuxmRg2N+HHss6/ eD0Yjg4WHgVYrq1kz2em7idpCC+gfVmSX5UXpBTzWrIsqoQXAJWaTsYXMROjlSqMbZubcL/k8y+O zS0EVkUFJzPCC2hfluR3y/A3ksp002aAGEDlogrjl0ZmYRwtPAJ8J+ZfZAwtt2KA908L3wF4vnTX lries2TCC2hfprI1yToZZfq7VXkBkMB0Mj6Nz5er5K+X6gt4gAgtM7aN2zGgH1gRlV18JbyA9mXa rBRekFGav9vpZCy8AEiitJGKG/fsczBUX8DDmH8B8Lds4UVLc8uqIryAxsWNbxbCC1KJVmfbSX7m LMP7AQjRD38v+Q2x6gt4gDhkkvW9Yv4FsGzZrilZ5s2mI7yAfshyw7tt7gXJZBqwmCnIBCDMBRiZ W0gdLjwCLIiWceZfAOQ5JDhj3sWKCC+gHzJtWmbaDIZM1ULCC4CkIsDI2lKm2HEqGx7G/Aug7wbD UcauHCovVkR4Af2gdRSsxqtEz6vwAiCxaAWauf2S6gt4OPMvgD7LeODB/faKCC+gHzKVr71SbkwG g+EoVZVQsvk3ANwicUuZYt8aDx4m+fyLjyqtgGfKeKj1y8IjLIXwAnog4aal1lFkkOnv1LBugHYc JZ1/sWWNBw+XPKw8FVYCz5AuAI3QmRUQXkB/ZNq8dGNLBpn+Tg0PA2hEzL/IeiLbGg8eIfH8izJo 92ThUYAfGAxHLxIO63ZYcIWEF9AfWkfBkkQv361Ez6fwAqAh08m4XNc/JfyNMs2KglocJJ1/Ue7p zLoBHkvLKL4jvID+yLZ56WQeNcs270J4AdCeo4wbmtlmRsGmRQvgrCHAe/MvgEfKGF6YL7lCwgvo iYSbl1nbIdC4qArKdHJUCStAg6K38nHC30x4AY80nYxPklZbdeZfAI8kvOA7wgvol0ybmLvR6xBq ky1YU3UB0K6M4UXGTQmogfkXQNOiUivbvAudDlZMeAH9cprst9UjlRpl+7vM9r4H4IFieHe209jb DqjA480N6zf/AmhVxgMOGUPlVIQX0C9aR8EzRJ/uTCdBrqNPMgDtUn0BPdHA/AvvfeA+GfeA3G+v mPACeiQWu1eJfuOtwXAkwKAmqi4AqEqs77Kd+jPAF57I/AugRXFt2En4q2kZtWLCC+gfraPgCaLF xW6y5054AdAP2frJCy/gebLOv9iyPgXusH/7w9VTebFiwgvon2yp8I7yYipxlO2FmE7Gbg4B+iHb 9T7bYQCoSvL5F7uD4SjduhpYuYxdN7RpXgPhBfRMbGZmW+Ra3LJRUXXxOtmr8HnhEQCaNJ2MvyRr DVo+W1VfwDPEhlnW+6S3DqgBM0m7HHRaRq2H8AL6Kd3pPItbNizjjaGqC4B+yXbdf7HwCPAo08n4 OPGBFfMvgJmsLaOEF2sgvIB+yripqfqCjUhadXEtvADonWxtC1RewHIcZKu8CuZfADNZZ50KL9ZA eAE9lLR1lOoLNiVl1UX0QgagP7LdQKu8gCWINV/WU8vmX0DPxT7PdsJnwbyLNRFeQH+dJPzNLWxZ q6RVF51TbAD9E3MvMhFewJLEBtpvSZ9P8y+g3zIO6u7cc6+P8AL6K2N4UU7mZD1VRE4ZA7OrqK4C oH/OE/3GwgtYogbmX7gmQM/E3JuMhwU7LaPWR3gBPRWncy4T/vbHC4/ACsQJMFUXAGSSqWVgxhYR UDvzL4BMss666Fyz1kd4Af2WsfpiW19U1iRrUCbgA+gvvZehx5LPv9gZDEfWsdAvWcOLSzMm10d4 Af2WMbwoDpUVs0qD4agsonYSPsnnCXueA9BT+tzD8iWff/FGm2Doh8FwdBBVVxll3UtLSXgBPRZJ 8aeEz8CW0+WsSvTdzFrdYxEF0G/6LwPZ51+cOKgGvZC5o4aWUWskvACyhgCvnMphRU6SngApg7qF FwAAdOZfALWKqouss68udTtYL+EF9FyUFZ8nfRZO4pQ8LEUEYq+SPpuCCwAAvooq+4Okz4b5F9A2 VRc8mPAC6BJvem7ZsGVZIgjL+vd0rZUaAAlpDQMrNJ2MSyu5d0mfY/MvoEExXzJr1UVnD2r9hBdA F61mMpYUd9pHsURZ20UVJ3G6DgAyEV7Aik0n46PklfauE9CI5PMlOy2jNkN4Acxk/gCxqOVZoudm 1nZRnaoLAADusR+Vutl8nX+hVTA04zDxgcFO1cVmCC+AmdOkC9rOUDeeYzAcvUy++f/J6Q8AAO4S FbpZq9V3HNSB/OLA6dvkv4jwYgOEF8BXsaDNvCg01I1Hm5tzkfn0R+aqKQAA1iD5/IvXUSkN5JV9 4/+zVs2bIbwA5h0nrr7oYqibRS2PcRynubJSdQHAPG00gTsln39xHBXTQDKxT7Ob/HVTdbEhwgvg mwaqLzqLWh5qMByVfpuvkz9hqi4AmCe8AH4k8/yLE/MvIJd4z2bfZ7qaTsZalW+I8AK4KXv1haFu /NBgONrruu598mdK1QUAN2Vb/5wtPAKslPkXwJplb9PcqbrYLOEF67bnGa9bLGYPk/8a226GuUtU 5rRwakLVBQA3qT4Ffsj8C2AdotvBqwaebKHpBgkvgAXTybikylcL38ilDPCWjvOdqMg5a+DkxztV FwDcQtso4EFi/sVl0mdLq2CoXLxHWzhw98mg7s0SXgB3yV590cWpHAEGXzUUXFw7+QHATfE5t73w DYC7mX8BLF28N1toF9W599484QVwqxhGdH7b95J5HaWK9NhccLHTwLNw6OQHALfI2J71YuERYG2i kjdrC6YdfeihWseN3HufTydja5UNE16wbkrZc2ll0/+9vqi9d9rI4uky2roBwE3pwgthPGxeHFr7 kPSleOWgGtQl3pOvG3lZzJmsgPCCdVPKnkgkzFkXsjd9FGD0U7QO223kl3dzBsBdsoUXGVvVQJOm k/Fh4vkX782/gDoMhqPSiu59Iy9Hqbo4W3iUtRNeAD9y1NDNpQCjZyK4aOXUxyeLJwBuMxiOXiSs MNSGAeqSdf5FcWr+BWxWhIgtdQnQ8aASwgvWJm6qSCbK+Vs67S3A6IFy8zIYji4aCi6uVV0AcI/9 u79VLS2joCLJ519s22iEzYn9vrNGBnQXV9o110N4wToJL5KKi3YLw7tnBBgNa2w494wh3QDcJ+O6 RuUFVMb8C+Cx4v77tKHgoksc5DZJeME6CS9yO2isN/HHaClEQxoNLs6d+gDgLklbRhVfFh4BNs78 C+ChGr7/1q65IsIL1kl4kViUER819mu9FmC0I25UvjS2cLp26gOAH8h60lh4AfUy/wK4V6PBRdfg vld6wgvWyQmI5KaT8XFj7aO6CDAuLHBzGwxH+4312Jw5iuAQABbE+iVlyO1UI9Qr1p9Zg1HzL2DF Gg4uVF1USHjBOqm8aENr7aO6+MC9UGKc02A4Kicj/tNgcPE5AkMAuMth0s+/rC1poDeibemnpL/v q7hHAJZsbjh3a8FFp+tBnYQXrFOWC5uhuPdIfgrnPuWEzplB3nmU0x6D4agMBnvb4K+nXRQA94pT j1nXZIZ1Qw6Z51+8HQxHewuPAk8WBz4vGg0uPuh6UCfhBWuR6UT7dDJ2M/UDyU/h3GcrBnk77V65 uUXTq0Z/xYPpZCxIBeA+R4mrDq23IYFYj2auvDf/Apak4VbNXVzjVGtVSnjBujjx0J5yCueq0d/t TczB0EaqQoPhqPzt/RHVMi0qJz5O+/46A3C3WKO8ufM/qJ9+0pBEHO7LWuVVNlmtq+GZGm7VPHPo 8GC9hBesi/CiMXFh32/4V9yJNlIttshKqfTWHAxHZbPjfcO/5uV0MvY3B8CPZB5Ge63SGXJJXnm/ a/4FPE3jrZpnzuMaR6WEFwmVnvxxKjxT+WOW8KK1QdQrFTeevzb8K5ZTBe/LhnkMpWJDIkQqf2+7 Db8G140HggAsQWzCZe41reoCcjL/Anok3jNfGm7VPGPWZOWEF8nEMOGPccOSoi9/XPCylJY5BfZI Dc+/mFc2zC9UYazfjWqLVktUZ/YNCAPgPrGuzn76UQsXSMj8C+iHqLYo+42/9+Ae/J178PoJLxKZ Cy5mXg+GowylTVLMxk0n44PEp3AealaFceHUznrEydL/Nl5tMfPbdDJ2EhWAO0UVaAsb/z7vICnz L6BtsddxkXyu1kOVls1ayiUgvEjiluBipuoAI042ZGqDovLi6fZ60narVD39Xt53WkmtxmA42h8M R18a76s579N0Mk5RSQfAZsSa+rSBE5CXTjhCblF5/znpL7EbJ8qBOdHx4DSqLbZ78tw4aJ2E8CKB e4KLmdfx39RoP9lN1p8Lj/AgUUbclwCjeB2tpI6UHy9HOeURLaL+06MF02Xi02sArEGsM86Sz7mY MRAT2lD2H66S/iZvymGphUehh6JF1KzjQeuzLeb9FpVkJCC8qNwDgouZj5VWYGQrwXIS7BmSlxE/ xVZUB3wRYjzdXGjxe09aRM2UoG8vgj8AWNBYcNFp2QJtiPVr5gBAFT29Nhda9Knjwcy5zge5CC8q 9ojgYqaqFlJxIcx2elp48UxRRvxb6l/i8YQYT9Dj0KITXADwI7Gx1lJwoWUUNCQOrmW97zP/gl6K 9lDHc6FF6wO5b7pOHrz2kvCiUk8ILmZKgHG66c3TwXD0Mml6q2xsCSLF/pT+F3m8+RDDaZ47xEyL voYWM/vKVAG4y9zAzFaCi07LKGhP3PdlnX+xY/4FfREHB0+iPdSbHoYWM/sOEOYjvKjQM4KLmdKn 7iwChLWbGyiYjovY8kwn44OeBhhdLATKTIz/lk16PVW/laUexiDu//Q4tCh+nU7GZwuPAsBfn5nH EfC3trEgvIA2mX8BFYoqi6O4B/899ij67J378Jz+2fcnoDZLCC5mdiLAOFpnL7e5vrwZh+2eLzzC s5QAI0K0lk4NPlbZpN8dDEdXEeod96llQtwMHPRs+Nd9fo3WagDwnai2OG503fTJISFoU3lvx5r/ j6S/YKmYf6mtHS2I/Zf9+OrzPsxNn6eTcbaZvAThRUWWGFzMlNNa72ebh6v+MI6L5GnS4KLTMmpl 9hrr1/xU21GeWU73XMbpw9MWF8lxzZl99bUc9Ta/CS4AuCnaTB41fiLS5x80rLRDHQxHZf7F+4S/ 5Wz+xUY6V8BzxBpib+4r637cKl3GgUqSEl5UYgXBxbzdaF/zodwYreLUUwznzjjjYp6TFisQJ3EE GN/biYX9+7mKjNOsJYxRcbUfCyaBxe0+rbMKDoD69SS0KK60aYD2lbVu3PdlrLj+Ov9iOhkfLnwH KhEHhl9E0LYX/3Tvfb/rOMyt+jMx4UUFVhxczCunvksbn1nrmmdVGsSGZfnZDxtJd91UrYgA417z FRldtC8rz9NZrTf68d6fP93hNb3fp5gBAwCztf9+j1oqatMA/XEQHQ0y7g+U+7ELldJsUuybdBFM zO67f3LP/WT7z937ZPOEFxu2xuBiZjZI+HW0rjmLU98XD0kiI+mdbVg2dcPlgrZaAowH242vtxFm XMYNwLevdZ4aiFOhL+ZOdrxUivoogguAnut5heJ13GsAPRD3fAcxHDij4wgw7A3wLLF39tON/429 uX+f3WfP/t099vL9qvKzDcKLDdpAcHHTTnyVU99dtK+5q3VS6xdTw7rXQIDxJLP36beWEnMVGt1c xdCXG+/fe0OOuVBiZra4+mnu371GzyO4AOih+Ix9qULxq+P71iNAe8pm4WA4epe0rfRWDPDec+3a jMFwlGGzWdhQv3eqqNohvNiQCoKL22z3+AIsjV0TAcbS7Mb/0O5d/4MRcrAZZbGkTQZAo+YOAcxC /xdzfaj1n/5Lqbow7wl6qKyD457vznuViu3EtcshpM3I+DdDXT65F2+L8GIDKg0u+k54sUYCDBr3 q1MeAPW6o5XDzM3vzcKJGZsqD6fqAvptPyrDMwa6pc32mTU9pKP7QYOEF2smuKjStT546zcXYBzP t0SC5AQXAM/zu8rBJqi6gJ6L+7198y+ANRFcNOoffX8C1klwUS3BxYaUBW18uHzq5RNAS8omzc+C CwD46lDVBRCHBN8lfSJm8y/uqtQD6iG4aJjwYk0EF1U77fsTsGnxIZN1UQsluNhTwQUAX10K84GZ 6D1/nvQJ2VFFBtUTXDROeLEGgovqCS8qEIvaX/v+PJDOZRnQqpwcAL45GWjA9QAADdNJREFU9FQA N+zHgZ+MXseeDlAfwUUPCC9WTHBRvc9K2usRp/T+nXhhS798jooL1xAA+MsHlYjATbFe3l/4Rh4f B8PRSy8sVEVw0RPCixUSXKSgpL0ycYJ9L060Q63eTSfjfcEFAHxz1XXdkacDuE3y+RfFqfkXUA3B RY8IL1ZEcJHC1XQy1jKqQnMBxue+PxdUp1QF/RJtzgCAvx0I9YH7xBo66yG1bYcfoQq/Ci76RXix AoKLNCw8KlZufsvJdoO8qchltIkSegLA97SLAh4q8/yLV4PhyFwf2IzrCC7s5fWM8GLJBBepHPf9 CcggTuf8bA4GG/YpgguDuQHge5fTydhmHvAg08n4S6nUSvxsvTf/AtbuOu7HBRc9JLxYPhviOXxS 1p5HnOR70XXded+fC9ZudrpDKwwAWHSdfAgvsAFRyfwh8XNv/gWsT+mA8MJBwv4SXizfnhPiKehX n0y0kdrTRoo1unS6AwDutR+nqAEeJSq2zL8A7lMOHr90kLDfhBdLNjdoWIBRr09usvKKNlL/TrzQ JYcPsUhyugMAbverORfAM5l/Adzm2mBuZoQXKxCbXT7E6nTttclvLiTMXGpMna7KjBW9uwHgXp9U JgLPZf4FcAsdEPiO8GJF4k32a5O/XG7Hys3aEG2kDmOY91Xfnw+WooRhL50iBYB7fXISEliWBuZf nJl/AUvzIYILHRD4RnixQgKM6lxGyyEaEhvNL83C4BkuZ9UWwk0AuJfgAli65PMvtsoA74VHgcco XVJ+cU/ObYQXKzYXYJiBsXlutBoVVRizWRjnfX8+eLByXX4Xsy1UWwDA/QQXwCplnn+xOxiOHJSE p/ncdd2LqMKCBcKLNYgAwxDvzXqn7Kx95TWeTsZ7AkMe4DxaRLnJAIAfE1wAKxXzLzLPnXs7GI72 Fh4F7jKbN7mv2oL7CC/WZG7AsA3V9Tu3QdkvERi+MNCbW8wWSHtxgwQA3E9wAaxF3Md9Svxsn5p/ AQ/yzrxJHkp4sUYRYLxM3Msxo6soP6Vn5gZ6/0srKSI4/m06Gb+wQAKAB/sguADWzPwLaFfZm/lX OWCs2oKHEl6sWZz03bOZuhZls1L5Wc+V91y0kvrZ+66XruNURwktjvv+ZADAI/waB0EA1ibu3w/M v4Cm6IDAkwkvNiBOhO9pabNSZaGzZ84FM+W0/VyIceWJ6YVPs7kWQkwAeLCyjv53tG8BWLu4jzf/ AvK7isMQOiDwZMKLDYqTTAYLL195Pg8FF9wmQowX8d4TYrTpU5SiHjjVAQCPch7VitbRwEY1Mv/i xcKj0A/zoYXDEDzLPz19m1XexIPhqNwclDfzTp+fiyVRccGDxAfoSZyIKWW9u5651K6jv+yRwAIA nuQ3LRaByhzG3NCMeyWz+RcvF74D7bqKe3KBBUuj8qICZaN9Ohm/1Ebq2QQXPNqNdlKfPYPpzM+0 UGkBAI93Hm2iBBdAVRqYf7EzGI5cW+mDS5UWrIrwoiLRRko//qe5VOLOc0SIsV/aDUWQqJ1b3WaL o5/MtACAJ7mOz1KHf4BqNTD/4s1gONpfeBTa8CkGcb8UWrAqwovKxAAbVRiP8yEulDYvebZycj+C xNlcjEvPalUsjgDg+WZViz5LgerFtSpzlfyJ+Rc05CrWEbM5kwZxs1JmXlQoNuEPB8NR+YA+1ov/ TuWC6ULJSsT7cDYX42Wc9tmP3qWs1+XstRBSAsCzfDIfCkiqtI8qVRjbCX988y/IbjZj8sQeHOsm vKhYlEfuDYajgxgonPFDelVKyntsI5N1iPdieR928X4sIcYrT/5KXc8FFlpZAMDTXceBqBOhBZBV ufeP9kt/JP0Vvs6/iCp/yGAWWJxOJ+NTrxibIrxIIEokT4QYXzktxkbNvR9/ihBDkLE8FkcAsDyX EVqcOvADtKAcahoMR791Xfc+6a9T5l+cudehYqXDyZl7cmoivEik5yGG0IKq3GgrNR9k7Gkt9ShX c4GF8lMAeJ6rubYOKheB5kwn4+PBcLSX+ADZ17bE9jaoyOcILM6sHaiR8CKhuRBjP1rZtHrqe9Y2 5tgHOzWbDzK6v1pL7c0FGTtevAWf505zeG8DwPMILIC+ST//otwzqopjA67ivVPuxy8cICQD4UVi UcJVPvRexEbpYSPVGJ/j5kuJGinFAuDrIiCqMvbmvvoYZpzPneSwOAKA57mc23g4cxAA6JsW5l9E W7+Dhe/A8pT78C/xNQsrBGakI7xoQNywlA++Uj75MjZJDxJtks763J/pyUtr4u/5NL6+isqM8vUy vlpqATfbULlQdgoAzzbbeJh9ttp4AGhj/sXrmH9xsvAdeLjz+C/LftqfsVb44mADLRFeNCY2Ci8i yKj1xPdsAJDNTXppvjKj+7s6YxZkvJj795pnZ1zNneD4EgskVRUA8DizTYeLuU2HP4UUAD/WwPyL 8vNf2BPhFpexHujm9g5mVRR/+puhT4QXDbvnxPf8BumLFZ76nl1s5xNgN2JwQ7wnvgs0ZqKaahZu /BTv2Rfx7VUFHNfxfu3mF0izDRULJQBYcH7jgdnn58zF3CaE9TDA8mSff3Fi/kVz5u+n582vBbqb awWHAeF2woueuXnieybmZsw2ROf//SHmL7g2NmGJ5t5PC+/bmyKcfBILJVirk4e8pyvg87wt5fX8 ue9PwnP4rOy9LNfuvm2A1n5t81m6YjH/Yu+Rexh9ZA2wRNYEsD7/53//+5+nGwAAAAAAqMY/vBQA AAAAAEBNhBcAAAAAAEBVhBcAAAAAAEBVhBcAAAAAAEBVhBcAAAAAAEBVhBcAAAAAAEBVhBcAAAAA AEBVhBcAAAAAAEBVhBcAAAAAAEBVhBcAAAD/vz07JgAAAEAYZP/U1tgBNQAAAFLkBQAAAAAAkCIv AAAAAACAFHkBAAAAAACkyAsAAAAAACBFXgAAAAAAACnyAgAAAAAASJEXAAAAAABAirwAAAAAAABS 5AUAAAAAAJAiLwAAAAAAgBR5AQAAAAAApMgLAAAAAAAgRV4AAAAAAAAp8gIAAAAAAEiRFwAAAAAA QIq8AAAAAAAAUuQFAAAAAACQIi8AAAAAAIAUeQEAAAAAAKTICwAAAAAAIEVeAAAAAAAAKfICAAAA AABIkRcAAAAAAECKvAAAAAAAAFLkBQAAAAAAkCIvAAAAAACAFHkBAAAAAACkyAsAAAAAACBFXgAA AAAAACnyAgAAAAAASJEXAAAAAABAirwAAAAAAABS5AUAAAAAAJAiLwAAAAAAgBR5AQAAAAAApMgL AAAAAAAgRV4AAAAAAAAp8gIAAAAAAEiRFwAAAAAAQIq8AAAAAAAAUuQFAAAAAACQIi8AAAAAAIAU eQEAAAAAAKTICwAAAAAAIEVeAAAAAAAAKfICAAAAAABIkRcAAAAAAECKvAAAAAAAAFLkBQAAAAAA kCIvAAAAAACAFHkBAAAAAACkyAsAAAAAACBFXgAAAAAAACnyAgAAAAAASJEXAAAAAABAirwAAAAA AABS5AUAAAAAAJAiLwAAAAAAgBR5AQAAAAAApMgLAAAAAAAgRV4AAAAAAAAp8gIAAAAAAEiRFwAA AAAAQIq8AAAAAAAAUuQFAAAAAACQIi8AAAAAAIAUeQEAAAAAAKTICwAAAAAAIEVeAAAAAAAAKfIC AAAAAABIkRcAAAAAAECKvAAAAAAAAFLkBQAAAAAAkCIvAAAAAACAFHkBAAAAAACkyAsAAAAAACBF XgAAAAAAACnyAgAAAAAASJEXAAAAAABAirwAAAAAAABS5AUAAAAAAJAiLwAAAAAAgBR5AQAAAAAA pMgLAAAAAAAgRV4AAAAAAAAp8gIAAAAAAEiRFwAAAAAAQIq8AAAAAAAAUuQFAAAAAACQIi8AAAAA AIAUeQEAAAAAAKTICwAAAAAAIEVeAAAAAAAAKfICAAAAAABIkRcAAAAAAECKvAAAAAAAAFLkBQAA AAAAkCIvAAAAAACAFHkBAAAAAACkyAsAAAAAACBFXgAAAAAAACnyAgAAAAAASJEXAAAAAABAirwA AAAAAABS5AUAAAAAAJAiLwAAAAAAgBR5AQAAAAAApMgLAAAAAAAgRV4AAAAAAAAp8gIAAAAAAEiR FwAAAAAAQIq8AAAAAAAAUuQFAAAAAACQIi8AAAAAAIAUeQEAAAAAAKTICwAAAAAAIEVeAAAAAAAA KfICAAAAAABIkRcAAAAAAECKvAAAAAAAAFLkBQAAAAAAkCIvAAAAAACAFHkBAAAAAACkyAsAAAAA ACBFXgAAAAAAACnyAgAAAAAASJEXAAAAAABAirwAAAAAAABS5AUAAAAAAJAiLwAAAAAAgBR5AQAA AAAApMgLAAAAAAAgRV4AAAAAAAAp8gIAAAAAAEiRFwAAAAAAQIq8AAAAAAAAUuQFAAAAAACQIi8A AAAAAIAUeQEAAAAAAKTICwAAAAAAIEVeAAAAAAAAKfICAAAAAABIkRcAAAAAAECKvAAAAAAAAFLk BQAAAAAAkCIvAAAAAACAFHkBAAAAAACkyAsAAAAAACBFXgAAAAAAACnyAgAAAAAASJEXAAAAAABA irwAAAAAAABS5AUAAAAAAJAiLwAAAAAAgBR5AQAAAAAApMgLAAAAAAAgRV4AAAAAAAAp8gIAAAAA AEiRFwAAAAAAQIq8AAAAAAAAUuQFAAAAAACQIi8AAAAAAIAUeQEAAAAAAKTICwAAAAAAoGPbAZXd amnYjGYeAAAAAElFTkSuQmCC"
      />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M32.77 19.86h.87c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.87c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82 0 0-.14-.02.2-.03z"
          fill="#f5eb1d"
        />
        <path
          d="M23.45 19.86h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.78c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82 0 0-.13-.02.2-.03z"
          fill="#fbb315"
        />
        <path
          d="M1.71 19.86h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03H1.7c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82-.01 0-.14-.02.2-.03z"
          fill="#ed2424"
        />
        <path
          d="M2.48 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ed2524"
        />
        <path
          d="M3.26 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ed2a24"
        />
        <path
          d="M4.03 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ed2f24"
        />
        <path
          d="M4.81 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ed3224"
        />
        <path
          d="M5.59 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ed3724"
        />
        <path
          d="M6.36 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ee3b24"
        />
        <path
          d="M7.14 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ee3f23"
        />
        <path
          d="M7.92 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ee4423"
        />
        <path
          d="M8.69 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ef4923"
        />
        <path
          d="M9.47 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ef4d23"
        />
        <path
          d="M10.25 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#ef5323"
        />
        <path
          d="M11.02 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f05822"
        />
        <path
          d="M11.8 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f05e22"
        />
        <path
          d="M12.58 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f16322"
        />
        <path
          d="M13.35 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f16922"
        />
        <path
          d="M14.13 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f26f21"
        />
        <path
          d="M14.91 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f37421"
        />
        <path
          d="M15.68 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f37a20"
        />
        <path
          d="M16.46 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f47f20"
        />
        <path
          d="M17.24 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f5841f"
        />
        <path
          d="M18.01 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f58a1f"
        />
        <path
          d="M18.79 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f6901e"
        />
        <path
          d="M19.57 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f7961d"
        />
        <path
          d="M20.34 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f89c1c"
        />
        <path
          d="M21.12 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#f9a11b"
        />
        <path
          d="M21.9 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#faa819"
        />
        <ellipse cx={23.06} cy={21.31} fill="#faae17" rx={0.55} ry={2.04} />
        <path
          d="M1.03 22.76c-.78 0-.78 0-.78-.02v-2.85c0-.02 0-.02.78-.02.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82.01 0 .14.02-.19.03z"
          fill="#ec2024"
        />
        <path
          d="M24.23 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fcb912"
        />
        <path
          d="M25 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03H25z"
          fill="#fbbf11"
        />
        <path
          d="M25.78 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fdc70a"
        />
        <path
          d="M26.56 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fccc08"
        />
        <path
          d="M27.33 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fcd206"
        />
        <path
          d="M28.11 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fcd700"
        />
        <path
          d="M28.89 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fdde00"
        />
        <path
          d="M29.66 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fde400"
        />
        <path
          d="M30.44 22.76v-2.89h.78c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#fbe800"
        />
        <path
          d="M31.22 22.76v-2.89H32c.16 0 .2.01.2.02v.02c0 .94 0 1.88-.01 2.82 0 .01.13.02-.2.03h-.77z"
          fill="#faec20"
        />
        <ellipse cx={32.38} cy={21.31} fill="#f7eb24" rx={0.55} ry={2.04} />
        <ellipse cx={1.37} cy={21.31} fill="#ec2224" rx={0.48} ry={2.04} />
        <path
          d="M90.91 19.86h.68a1 1 0 01.19.01V22.72c0 .01.1.02-.19.03h-.68c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82-.01 0-.14-.02.19-.03z"
          fill="#6a52a1"
        />
        <path
          d="M80.72 22.76h-.68c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82 0-.01-.13-.02.2-.03h.68a1 1 0 01.19.01V22.73c-.01.01.09.02-.2.03z"
          fill="#3b56a5"
        />
        <path
          d="M69.85 22.76h-.68c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82 0-.01-.13-.02.2-.03h.68a1 1 0 01.19.01V22.73c-.01.01.09.02-.2.03z"
          fill="#33c5f3"
        />
        <path
          d="M66.74 22.76h-.68c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82 0-.01-.13-.02.2-.03h.68a1 1 0 01.19.01V22.73c-.01.01.09.02-.2.03z"
          fill="#6dcbdb"
        />
        <path
          d="M41.89 22.76h-.68c-.16 0-.2-.01-.2-.02v-.02c0-.94 0-1.88.01-2.82 0-.01-.13-.02.2-.03h.68a1 1 0 01.19.01V22.73c-.01.01.09.02-.2.03z"
          fill="#91c73e"
        />
        <path
          d="M33.64 22.76v-2.89h.49a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.49z"
          fill="#ede712"
        />
        <path
          d="M99.07 22.76h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03h.49c.13 0 .14.01.14.01V22.73c0 .01.1.02-.14.03z"
          fill="#af509d"
        />
        <path
          d="M97.13 22.76h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03h.49c.11 0 .15.01.15.01v2.86c-.01 0 .08.01-.15.02z"
          fill="#9b509e"
        />
        <path
          d="M90.91 19.86v2.89h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#6452a1"
        />
        <path
          d="M86.26 22.76h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03h.49c.11 0 .15.01.15.01v2.86c-.01 0 .08.01-.15.02z"
          fill="#4452a2"
        />
        <path
          d="M36.55 22.76h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03h.49c.11 0 .15.01.15.01v2.86s.09.01-.15.02z"
          fill="#cddb28"
        />
        <path
          d="M82.66 19.86h.49c.11 0 .15.01.15.01v2.86c0 .01.09.02-.14.02h-.49a1 1 0 01-.19-.01v-.01-2.84c-.01-.01-.1-.02.18-.03z"
          fill="#3853a3"
        />
        <path
          d="M80.04 19.86v2.89h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#3c57a6"
        />
        <path
          d="M74.9 19.86h.49c.11 0 .15.01.15.01v2.86c0 .01.09.02-.14.02h-.49a1 1 0 01-.19-.01v-.01-2.84c-.01-.01-.11-.02.18-.03z"
          fill="#4274b8"
        />
        <path
          d="M69.17 19.86v2.89h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#4dc7eb"
        />
        <path
          d="M66.06 19.86v2.89h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#70cbd4"
        />
        <path
          d="M49.76 22.76h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03h.49a1 1 0 01.19.01V22.73c0 .01.09.02-.19.03z"
          fill="#69bc45"
        />
        <path
          d="M47.43 22.76h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03h.49c.11 0 .15.01.15.01v2.86c-.01 0 .08.01-.15.02z"
          fill="#6fbd44"
        />
        <path
          d="M41.21 19.86v2.89h-.49a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#99ca3c"
        />
        <path
          d="M40.73 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#9cca3b"
        />
        <path
          d="M41.89 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#8dc63f"
        />
        <path
          d="M42.28 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#8ac53f"
        />
        <path
          d="M42.67 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#86c440"
        />
        <path
          d="M43.06 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#84c341"
        />
        <path
          d="M43.45 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#80c241"
        />
        <path
          d="M43.83 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#80c242"
        />
        <path
          d="M44.22 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#7cc142"
        />
        <path
          d="M44.61 22.76v-2.89H45a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#7ac043"
        />
        <path
          d="M45 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03H45z"
          fill="#77bf43"
        />
        <path
          d="M45.39 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#76bf43"
        />
        <path
          d="M45.78 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#73be44"
        />
        <path
          d="M46.16 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#72be44"
        />
        <ellipse cx={46.75} cy={21.31} fill="#70be44" rx={0.27} ry={2.04} />
        <path
          d="M40.34 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#a1cc3a"
        />
        <path
          d="M99.26 19.86c.33 0 .4 0 .4.01-.01.96-.01 1.91 0 2.87 0 .01-.07.01-.4.01-.16-.01-.09-.01-.09-.02v-1.31-1.54s-.07-.01.09-.02z"
          fill="#b6519d"
        />
        <path
          d="M47.72 19.86h.39a1 1 0 01.19.01V22.72c0 .01.1.02-.19.03h-.39c-.11 0-.15-.01-.15-.01v-.01-2.85c.01 0-.08-.01.15-.02z"
          fill="#6cbd45"
        />
        <path
          d="M48.11 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6abc45"
        />
        <path
          d="M48.49 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6abc45"
        />
        <ellipse cx={49.08} cy={21.31} fill="#69bc45" rx={0.27} ry={2.04} />
        <path
          d="M39.95 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#a5cd39"
        />
        <path
          d="M49.76 22.76v-2.89h.39c.12 0 .15.01.15.01V22.73c0 .01.09.02-.14.02-.15.01-.27.01-.4.01z"
          fill="#68bc45"
        />
        <path
          d="M34.13 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#e7e513"
        />
        <g fill="#69bc45">
          <path d="M50.82 22.76h-.39c-.11 0-.15-.01-.15-.01v-.01-2.85c0-.01-.09-.02.14-.02h.39a1 1 0 01.19.01V22.73c.01.01.11.02-.18.03z" />
          <path d="M50.82 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z" />
          <path d="M51.21 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z" />
          <path d="M51.6 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z" />
        </g>
        <path
          d="M51.99 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6abc45"
        />
        <path
          d="M52.38 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6abc45"
        />
        <path
          d="M52.77 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6abc45"
        />
        <path
          d="M53.15 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6cbd45"
        />
        <path
          d="M53.54 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6cbd45"
        />
        <path
          d="M53.93 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6dbd45"
        />
        <path
          d="M54.32 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6dbd45"
        />
        <path
          d="M54.71 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6ebd44"
        />
        <path
          d="M55.09 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fbd44"
        />
        <path
          d="M55.48 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fbd44"
        />
        <path
          d="M55.87 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fbd46"
        />
        <path
          d="M56.26 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70be4b"
        />
        <path
          d="M56.65 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70be54"
        />
        <path
          d="M57.04 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70bf5b"
        />
        <path
          d="M57.42 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#71bf5f"
        />
        <path
          d="M57.81 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70bf66"
        />
        <path
          d="M58.2 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70c06d"
        />
        <path
          d="M58.59 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70c073"
        />
        <path
          d="M58.98 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70c179"
        />
        <path
          d="M59.37 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc17f"
        />
        <path
          d="M59.75 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6ec184"
        />
        <path
          d="M60.14 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc289"
        />
        <path
          d="M60.53 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70c38f"
        />
        <path
          d="M60.92 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc395"
        />
        <path
          d="M61.31 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6ec39a"
        />
        <path
          d="M61.7 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc4a0"
        />
        <path
          d="M62.08 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#70c5a6"
        />
        <path
          d="M62.47 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc5aa"
        />
        <path
          d="M62.86 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6ec6af"
        />
        <path
          d="M63.25 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc6b5"
        />
        <path
          d="M63.64 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc7ba"
        />
        <path
          d="M64.03 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6fc8c0"
        />
        <path
          d="M64.41 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6ec8c4"
        />
        <path
          d="M64.8 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6ec9c9"
        />
        <ellipse cx={65.38} cy={21.31} fill="#6fcacf" rx={0.27} ry={2.04} />
        <path
          d="M39.56 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#a9cf37"
        />
        <path
          d="M39.18 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#add036"
        />
        <path
          d="M66.74 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6acbdf"
        />
        <path
          d="M67.13 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#67cae1"
        />
        <path
          d="M67.52 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#63cae3"
        />
        <path
          d="M67.91 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#5dc9e6"
        />
        <ellipse cx={68.49} cy={21.31} fill="#53c7e8" rx={0.27} ry={2.04} />
        <path
          d="M38.79 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#b2d235"
        />
        <path
          d="M38.4 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#b7d333"
        />
        <path
          d="M69.85 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#31c2f1"
        />
        <path
          d="M70.24 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3abced"
        />
        <path
          d="M70.63 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#41b4e7"
        />
        <path
          d="M71.01 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#43afe3"
        />
        <path
          d="M71.4 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#44a6dd"
        />
        <path
          d="M71.79 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#46a0d9"
        />
        <path
          d="M72.18 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4899d3"
        />
        <path
          d="M72.57 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4993cf"
        />
        <path
          d="M72.96 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#468bca"
        />
        <path
          d="M73.34 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4787c7"
        />
        <path
          d="M73.73 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4480c1"
        />
        <path
          d="M74.12 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#437cbf"
        />
        <ellipse cx={74.7} cy={21.31} fill="#4276ba" rx={0.27} ry={2.04} />
        <path
          d="M38.01 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#bbd531"
        />
        <path
          d="M98.58 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#aa509d"
        />
        <path
          d="M75.67 19.86h.39a1 1 0 01.19.01V22.72c0 .01.1.02-.19.03h-.39c-.11 0-.15-.01-.15-.01v-.01-2.85c.01 0-.08-.01.15-.02z"
          fill="#416cb3"
        />
        <path
          d="M76.06 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#406ab2"
        />
        <path
          d="M76.45 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4067b0"
        />
        <path
          d="M76.84 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3f64ae"
        />
        <path
          d="M77.23 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4061ac"
        />
        <path
          d="M77.62 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3f60ab"
        />
        <path
          d="M78 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03H78z"
          fill="#3f5eaa"
        />
        <path
          d="M78.39 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3d5ca9"
        />
        <path
          d="M78.78 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3d5aa7"
        />
        <ellipse cx={79.36} cy={21.31} fill="#3e59a7" rx={0.27} ry={2.04} />
        <path
          d="M37.62 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#bfd62f"
        />
        <path
          d="M37.23 19.86v2.89h-.39a.61.61 0 01-.15-.01v-.01-2.84c0-.01-.09-.02.14-.02.14-.01.27-.01.4-.01z"
          fill="#c4d82d"
        />
        <path
          d="M80.72 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3c55a4"
        />
        <path
          d="M81.11 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3c54a4"
        />
        <path
          d="M81.5 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3a53a4"
        />
        <path
          d="M81.89 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3953a4"
        />
        <ellipse cx={82.47} cy={21.31} fill="#3953a4" rx={0.27} ry={2.04} />
        <path
          d="M98.2 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#a7509e"
        />
        <path
          d="M97.81 19.86v2.89h-.39a.61.61 0 01-.15-.01v-.01-2.84c0-.01-.09-.02.14-.02.14-.01.27-.01.4-.01z"
          fill="#a3509e"
        />
        <path
          d="M83.83 22.76h-.39c-.11 0-.15-.01-.15-.01v-.01-2.85c0-.01-.09-.02.14-.02h.39a1 1 0 01.19.01V22.73c.01.01.11.02-.18.03z"
          fill="#3953a3"
        />
        <path
          d="M83.83 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3b52a3"
        />
        <path
          d="M84.22 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3c52a3"
        />
        <path
          d="M84.6 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#3d52a3"
        />
        <path
          d="M84.99 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4052a2"
        />
        <ellipse cx={85.58} cy={21.31} fill="#4252a2" rx={0.27} ry={2.04} />
        <path
          d="M36.07 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#d2dd26"
        />
        <path
          d="M34.52 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#e2e318"
        />
        <path
          d="M86.93 22.76h-.39c-.11 0-.15-.01-.15-.01v-.01-2.85c0-.01-.09-.02.14-.02h.39a1 1 0 01.19.01V22.73c.02.01.11.02-.18.03z"
          fill="#4852a2"
        />
        <path
          d="M86.93 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4a52a2"
        />
        <path
          d="M87.32 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4d53a2"
        />
        <path
          d="M87.71 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#4f53a2"
        />
        <path
          d="M88.1 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#5252a2"
        />
        <path
          d="M88.49 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#5652a2"
        />
        <path
          d="M88.88 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#5953a2"
        />
        <path
          d="M89.26 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#5b52a2"
        />
        <path
          d="M89.65 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#5e52a2"
        />
        <ellipse cx={90.24} cy={21.31} fill="#6252a2" rx={0.27} ry={2.04} />
        <path
          d="M35.68 19.86v2.89h-.39a1 1 0 01-.19-.01v-.01-2.84c0-.01-.1-.02.19-.03z"
          fill="#d8df21"
        />
        <ellipse cx={35.1} cy={21.31} fill="#dce11e" rx={0.27} ry={2.04} />
        <path
          d="M91.59 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#6f51a1"
        />
        <path
          d="M91.98 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#7251a1"
        />
        <path
          d="M92.37 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#7551a0"
        />
        <path
          d="M92.76 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#7951a0"
        />
        <path
          d="M93.15 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#7d51a0"
        />
        <path
          d="M93.54 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#7f52a0"
        />
        <path
          d="M93.92 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#8351a0"
        />
        <path
          d="M94.31 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#85519f"
        />
        <path
          d="M94.7 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#8a509f"
        />
        <path
          d="M95.09 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#8c509f"
        />
        <path
          d="M95.48 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#92509e"
        />
        <path
          d="M95.87 22.76v-2.89h.39a1 1 0 01.19.01V22.73c0 .01.1.02-.19.03h-.39z"
          fill="#94509e"
        />
        <ellipse cx={96.45} cy={21.31} fill="#99509e" rx={0.27} ry={2.04} />
        <ellipse cx={86.4} cy={21.31} fill="#4652a2" rx={0.21} ry={2.04} />
        <ellipse cx={97.27} cy={21.31} fill="#9f509e" rx={0.21} ry={2.04} />
        <ellipse cx={83.29} cy={21.31} fill="#3953a3" rx={0.21} ry={2.04} />
        <ellipse cx={36.7} cy={21.31} fill="#c9da2b" rx={0.21} ry={2.04} />
        <ellipse cx={75.53} cy={21.31} fill="#4370b6" rx={0.21} ry={2.04} />
        <ellipse cx={50.29} cy={21.31} fill="#68bc45" rx={0.21} ry={2.04} />
        <ellipse cx={47.57} cy={21.31} fill="#6dbd45" rx={0.21} ry={2.04} />
        <ellipse cx={99.17} cy={21.31} fill="#b2509d" rx={0.14} ry={2.04} />
      </g>
    </svg>
  );
};

IconJoybirdLogoPride.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default IconJoybirdLogoPride;
